<template>
	<div class="btn-group">
		<slot></slot>
	</div>
</template>
<script>
	export default {
		name: 'XButtonGroup'
	}
</script>